<div class="card">
  <app-header
    titulo="Contratos com erros"
    descricao="Contratos com algum erro na integração"
  ></app-header>

  <app-contratos statusContrato="ER"></app-contratos>

</div>
